// import logo from './logo.svg'
import './App.css';
import AppRouter from "./config/AppRouter";
import { BrowserRouter as Router, useNavigate } from "react-router";
import { setNavigator } from './store/useAuthStore';
import { useEffect } from 'react';
import './lib/axiosInterceptor.js';
import { Toaster } from 'react-hot-toast';


function InitNavigator() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  return null;
}



function App() {
  return (
    <Router base='/5stardashboard'>
      <InitNavigator />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            padding: "12px 20px",   
            borderRadius: "8px",    
            color: "#fff",         
          },
          success: {
            style: {
              background: "green",  
            },
          },
          error: {
            style: {
              background: "red",   
            },
          },
        }}
      />
      <AppRouter />
    </Router>
  );
}

export default App;
